import { jsx as _jsx } from "react/jsx-runtime";
import { MarkdownBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { BlockLayout } from '../fragments/BlockLayout';
export const PlainText = ({ block: { content, id, layout } }) => {
    const [resolver] = useResolveValue();
    const resolved = {
        content: resolver.resolveString(content)
    };
    return (_jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(MarkdownBase, { "data-test": id, markdown: resolved.content }) })));
};
